<template>
    <div
        class="l-ss-c-offer-params"
        v-if="allParams.length">
        <offer-params-wrapper
            v-for="([title, items]) in allParams"
            :key="title"
            :title="title"
            :items="items"
            :available-items="availableParams[title]"
            v-model="selectedParams[title]"
            @change="changeOffer({ title, item: $event })"/>
    </div>
</template>

<script>
    import { ref } from '@vue/composition-api';
    import OfferParamsWrapper from '@/core/components/offer/offer-params/offer-params-wrapper.vue';

    import useOfferParamsTree from '@/core/components/offer/offer-params/use-offer-params-tree';

    export default {
        components: { OfferParamsWrapper },
        props: {
            offer: {
                type: Object,
            },
            offerSettings: {
                type: Object,
            },
        },
        setup(props, { emit }) {
            const { offer, offerSettings } = props;

            const selectedGroupedParams = offer.selectedGroupedParams || {};

            const groupedParams = ref(offer.groupedParams || {});
            const selectedParams = ref(selectedGroupedParams);

            let allParams = [];
            let availableParams = ref({});

            let getOfferByParams = null;

            if (groupedParams.value) {
                const orderForGroupedParamNames = offerSettings.orderForGroupedParamNames;
                allParams = Object.entries(groupedParams.value);

                allParams.sort((a, b) => {
                    const aIndex = orderForGroupedParamNames.indexOf(a[0]);
                    const bIndex = orderForGroupedParamNames.indexOf(b[0]);
                    const NOT_FOUND_INDEX = 999;
                    const aOrder = aIndex === -1 ? NOT_FOUND_INDEX : aIndex;
                    const bOrder = bIndex === -1 ? NOT_FOUND_INDEX : bIndex;

                    if (aOrder !== bOrder) {
                        return aOrder - bOrder;
                    }
                    return a[0].localeCompare(b[0]);
                });
                allParams.forEach(([paramName]) => {
                    availableParams.value[paramName] = [];
                });
            }

            const processParams = (currentSelectedParam) => {
                const {
                    newSelectedParams,
                    newAvailableParams,
                    newOffer,
                } = getOfferByParams(allParams, selectedParams.value, currentSelectedParam);

                selectedParams.value = newSelectedParams;
                availableParams.value = newAvailableParams;

                return newOffer;
            };

            const changeOffer = (currentParam) => {
                selectedParams.value[currentParam.title] = currentParam.item;

                const newOffer = processParams(currentParam);

                emit('change-offer', newOffer);
            };

            const loadAllIntersections = () => {
                emit('load-grouped-offers', { offer, callback: onLoadGroupedOffers });
            };

            const onLoadGroupedOffers = (offers) => {
                getOfferByParams = useOfferParamsTree(offers);

                processParams();
            };

            if (allParams.length) {
                loadAllIntersections();
            }

            return {
                allParams,
                selectedParams,
                groupedParams,
                availableParams,
                changeOffer,
            };
        },
    };

</script>
